module.exports = __webpack_public_path__ + "media/images/gallery/constellations/lyra/lyr_dir-deb449d3ace50bfbc1279f4f6fbbb1ea.gif";